import './popUp';
import './toggleScroll';

const cookieNotice = document.querySelector('.cookie-notice');
const cookieBtn = document.querySelector('.js-cookie');

function setCookie(cname, cvalue, exdays) {
  let d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = 'expires='+d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}


function getCookie(cname) {
  const name = cname + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for( let i = 0; i < ca.length; i++ ) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function showNotice() {
  cookieNotice.classList.add('is-visible');
}

function showNewsletterPopup() {
  openPopUp('popup-newsletter');
  setCookie('newsletter_cookie', 1, 30);

}

function hideNotice() {
  cookieNotice.classList.remove('is-visible');
}

function checkCookies() {
  const acceptCookie = getCookie('accept_cookie');
  const newsletterCookie = getCookie('newsletter_cookie');

  if (acceptCookie == 1) {
    if(newsletterCookie == null || newsletterCookie == '') {
      setTimeout( () => {
        showNewsletterPopup();
      }, 2000);

    } else {
      return false;
    }

  } else {
    showNotice();
  }
}

// Check Cookie on DOM Ready
checkCookies();

// Set Cookie "I Agree"
if(cookieBtn) {
  cookieBtn.addEventListener('click', (e)=>{
    e.preventDefault;
    setCookie('accept_cookie', 1, 356);
    hideNotice();
  });
}



// WEBPACK FOOTER //
// ./scripts/util/Cookie.js